<template>
    <div>
        <comment-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"></comment-filter-link>
        <comment-list-link :listLayout="listLayout" :commentData="List" :paginationData="filterSet.page"></comment-list-link>
        <pagination-link :finishGetList="finishGetList" :listLength="List.length" :paginationData="filterSet.page"
                         :paginationLayout="paginationLayout"></pagination-link>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import postUtil from "@/components/post/postUtil";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import CommentFilterLink from "@/components/post/CommentFilterLink";
import CommentListLink from "@/components/post/CommentListLink";
import PaginationLink from "@/components/post/PaginationLink";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";

const {filterConfig} = postUtil;

export default {
    name: "CommentListComponent",
    mixins: [filterMixins, listMixins, postUtil, alertMixins],
    components: {PaginationLink, CommentListLink, CommentFilterLink},
    provide() {
        return {
            postSetPage: this.setPage,
            postSetFilter: this.setFilter,
            postSetData: this.setData,
            setComment: this.setComment,
        }
    },
    props: {
        commentType: '',
        postKey: 0,
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            inputLayout: '',
            getFunc: '',
            listApiParamSet: {},
            pageRow: 10,

            content: '',
            mention: {},

            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        EventBus.$on('deleteComment', this.deleteComment);
    },
    beforeDestroy() {
        EventBus.$off('deleteComment')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let commentConfig = this.returnPostConfig(this.commentType);
            this.filterLayout = commentConfig.filterLayout;
            this.listLayout = commentConfig.listLayout;
            this.paginationLayout = commentConfig.paginationLayout;
            this.inputLayout = commentConfig.inputLayout;
            this.getFunc = commentConfig.getFunc;
            this.listApiParamSet = commentConfig.listApiParamSet;
            this.pageRow = commentConfig.pageRow;


            commentConfig.pageRow && commentConfig.pageRow != this.filterSet.page.size ? this.pageRow = commentConfig.pageRow : '';

            this.paginationType = 'lazyload';
            let params = JSON.parse(JSON.stringify(this.listApiParamSet));

            params.pa = this.postKey;

            let listOptions = {
                url: this.$api.$post[this.getFunc],
                defaultParams: params,
            }
            this.initList('api', listOptions);
            this.newDeleteClass();
        },
        newDeleteClass() {
            let deleteApiParams = {

                wr_parent: this.postKey,
            }
            let options = {
                func: this.$api.$post.deletePostComment,
                apiParamSet: deleteApiParams,
                keyName: 'wr_id',
                successType: 1,
                errorTypes: {},
                afterFunc: this.deleteAfterFunc,
            }

            this.DeleteClass = new DeleteClass(options);
        },
        setData(key, value) {
            this[key] = value;
        },
        deleteComment(data) {
            this.createConfirm({
                content: `삭제하시겠습니까?`,
                confirmText: '예',
                cancelText: '아니오',
                confirm: () => {
                    this.runDelete(data);
                }
            })
        },
        deleteAfterFunc(data) {
            EventBus.$emit('apiLoading', true);
            this.postCommentListDeleteAfterFunc('wr_id', data);
            EventBus.$emit('commentAfterFunc', 'delete');
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    EventBus.$emit('commentLayoutAfter')
                }
            })
        },
        runDelete(data) {
            this.DeleteClass.runDelete(data);
        },

        postCommentListDeleteAfterFunc(key = 'wr_id', value) {
            this.sendElastic('del');
            let commentIndex = this.List.findIndex(comment => comment[key] == value);
            if (commentIndex < 0) {
                return false;
            }
            this.List.splice(commentIndex, 1);
            this.filterSet.page.total = this.filterSet.page.total - 1;
            if (this.paginationType === 'lazyload' && (this.List.length < this.filterSet.page.total)) {
                let params = JSON.parse(JSON.stringify(this.listApiParamSet));
                params.pa = this.postKey;
                params.page = this.filterSet.page.page * this.filterSet.page.size;
                params.sp = 1;
                this.$api.$post[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1 && res.List.length > 0) {
                        this.List.push(res.List[0]);
                    }
                })
            }
        },

        sendElastic(type = 'add') {
            EventBus.$emit('apiLoading', true)

            let params = {
                key: this.postKey,
                type: 'post',
                pwd:'justreet-index'
            }
            try {

                this.$api.$elastic.createElastic(params).then(res => res.Data.Result).then(res => {
                    setTimeout(() => {
                        EventBus.$emit('apiLoading', false)

                        if(type === 'add') {
                            EventBus.$emit('elasticListCommentAddAfter', 'wr_id', this.postKey);
                        }else if(type === 'del') {
                            EventBus.$emit('elasticListCommentDelAfter', 'wr_id', this.postKey);
                        }
                    }, 500)
                })

            } catch (e) {
                EventBus.$emit('apiLoading', false)

            }

        },
        returnBlindType(type) {
            switch (type) {
                case 1:
                    return true
                case -366:
                    return '다른 사용자에게 이미 신고된 글입니다.'
                case -459:
                    return '본인 댓글에는 신고가 불가능합니다.'
                default :
                    return '신고에 실패했습니다.'
            }
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
